import { useEffect } from 'react';
import { useAppSelector } from '../../common/hooks';
import ReviewPlanDetails from '../../containers/review-plan-details';
import { useLocation, useNavigate } from 'react-router-dom';
import { ADVISOR_ROUTES } from '../../routes/routeConstants';
import { CallRunpipePropsType } from '../../common/types/clients-entity';
import { AdviceGoalPayloadType } from '../../features/client-goals';

interface ReviewPlanDetailsStepProps {
    // eslint-disable-next-line no-unused-vars
    updateStep?: (step: number | ((prev: number) => number)) => void;
    callRunpipe: CallRunpipePropsType;
    goalsWithNoFundingSource: AdviceGoalPayloadType['formFields'];
}

export const ReviewPlanDetailsStep = ({
    updateStep,
    callRunpipe,
    goalsWithNoFundingSource
}: ReviewPlanDetailsStepProps) => {
    const adviceGoals = useAppSelector((state) => state.adviceGoals);
    const navigate = useNavigate();
    const location = useLocation();
    useEffect(() => {
        if (location.pathname !== ADVISOR_ROUTES.PLAN_DETAILS) navigate(ADVISOR_ROUTES.PLAN_DETAILS, { replace: true });
    }, []);
    return adviceGoals?.response?.length > 0 ? (
        <ReviewPlanDetails
            updateStep={updateStep}
            callRunpipe={callRunpipe}
            goalsWithNoFundingSource={goalsWithNoFundingSource}
        />
    ) : null;
};
